import styled from "styled-components";

import { colours } from "../../styles/colours.constants";
import { satoshi500 } from "../../styles/font.constants";

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

type LabelStyleProps = {
	$disabled: boolean;
};

export const Label = styled.label<LabelStyleProps>`
	${satoshi500}
	font-size: 1rem;
	color: ${colours.black};
	cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
	opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
`;

export const Checkbox = styled.input`
	appearance: none;
	margin: 0;
	width: 1.25rem;
	height: 1.25rem;
	border-radius: 50%;
	border: 1px solid ${colours.greyDarker};
	background-color: ${colours.white};
	cursor: pointer;
	position: relative;

	&:disabled {
		cursor: not-allowed;
		border-color: ${colours.greyDark};
		background-color: ${colours.greyLight};
	}

	&:checked {
		border-color: ${colours.black};
	}

	&:checked::after {
		content: "";
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 0.8rem;
		height: 0.8rem;
		border-radius: 50%;
		background-color: ${colours.black};
	}

	// Needs to win over both the plain &:disabled and &:checked rules above,
	// regardless of source order — otherwise a disabled-but-checked radio
	// (e.g. re-disabled after selection) would render fully coloured again.
	&:disabled:checked {
		border-color: ${colours.greyDark};
	}

	&:disabled:checked::after {
		background-color: ${colours.greyDark};
	}
`;
